import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Box, Button, TextField,  Container,Typography, Alert } from '@mui/material';
import axios from 'axios';
import { useNavigate, Link  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Footer from '../components/SFooter';
import Header from '../components/SHeader';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    const navigate = useNavigate();

    const { login , logout, logoutSupplier} = useAuth();
    
     
    useEffect(() => {
         logout(); 
      logoutSupplier(); 
    // Call the onLogout function when the component loads
  //  onLogout();
  }, []);
    
    
    
const handleLogin = (e) => {
    e.preventDefault();
    setErrorMessage(''); 
       console.log('Email:', email );
               const newUser = {
              email: email,
              password: password,
                     wouldBePartner: 0
            };
      
     //  
  //  axios.post(`${backendUrl}/api/auth/login`, { email, password })
       axios.post(`${backendUrl}/api/users/login`, newUser)
        .then((response) => {
          const user = response.data;
           localStorage.setItem('token', user.token);
           console.log(user);
          if (user.active)  {
          // Redirect to dashboard if user exists
            console.log('Email:', response.data.userId);
            const userId = response.data.userId;
          
              if(user.wouldBePartner==1){
                    setErrorMessage('you already registed the email as supplier. Please user supplier login page.');
                   user.wouldBePartner=0;
                  return;
              }
          
              if(user.authorized){
                  login(user); 
                  navigate('/admindashboard');
                 }else{
                     if(user.provider){
                        console.log("you already registed using the SSO. Please login using SSO");
                        // Catch and handle errors
                        setErrorMessage('you already registed using the SSO. Please login using SSO.');
                     }else{
                         console.log("Please enter the correct password");
                         setErrorMessage('Please enter the correct password.');
                     }
                 }
                
            }
        
      
        }).catch(err => {
            console.error('Login failed', err);
           setErrorMessage('An error occurred during login. Please try again.');
        });
};
    

return (
    
    
          <div>
      <Header />
   <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        justifyContent: 'center',
        padding: 3,
      }}
    >

 {/* Error Message Display */}
        {errorMessage && (
          <Alert severity="error" style={{ marginBottom: '20px' }}>
            {errorMessage}
          </Alert>
        )}

      {/* Divider Text */}
      <Typography variant="h6" sx={{ my: 2 }}>
         Login with Email/Password
      </Typography>
  

      {/* Email/Password Login Form */}
      <form onSubmit={handleLogin} style={{ width: '100%', maxWidth: '400px' }}>
        {/* Email Input */}
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Password Input */}
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Submit Button */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          sx={{ marginBottom: 4 }}
        >
          Login with Email/Password
        </Button>
      </form>

 {/* Forgot Password Link */}
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <Link to="/forgot-password" style={{ textDecoration: 'none', color: '#3f51b5' }}>
            Forgot Password?
          </Link>
        </div>


</Container>
  <Footer />
      </div>


);
};

export default AdminLogin;
